import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeEmailTemplateCreate,
  detail: routeEmailTemplateDetail,
  home: routeEmailTemplateHome,
  root: routeEmailTemplateRoot,
} = createDoctypeRoutes({
  createName: 'new-email-template',
  createPath: 'new-email-template',
  detailName: 'email-template-detail',
  doctype: DOCTYPES.EMAIL_TEMPLATE,
  homeName: 'email-template',
  path: 'email-template',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/settings/email/emailTemplate/AddEmailTemplate.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/settings/email/emailTemplate/ViewEmailTemplate.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/email/ViewEmailSettings.vue'),
  },
})

export {
  routeEmailTemplateCreate,
  routeEmailTemplateDetail,
  routeEmailTemplateHome,
  routeEmailTemplateRoot,
}
